import { Component, OnInit } from '@angular/core';
import {
  ProformaService,
  ProformaInvoiceDTO,
} from '../services/proforma.service';

@Component({
  selector: 'app-proforma',
  templateUrl: './proforma.component.html',
  styleUrls: ['./proforma.component.scss'],
})
export class ProformaComponent implements OnInit {
  proformas: ProformaInvoiceDTO[] = [];
  paginatedProformas: ProformaInvoiceDTO[] = [];

  selectedProforma: ProformaInvoiceDTO | null = null;
  isEditing = false;

  currentPage = 1;
  pageSize = 5;
  totalPages = 0;
  showItems: any;

  constructor(private proformaService: ProformaService) {}

  ngOnInit(): void {
    this.getAllProformas();
  }

  getAllProformas(): void {
    this.proformaService.getAll().subscribe({
      next: (data) => {
        this.proformas = data;
        this.totalPages = Math.ceil(this.proformas.length / this.pageSize);
        this.setPage(1);
      },
      error: (err) => console.error('Failed to fetch proformas', err),
    });
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    const start = (page - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedProformas = this.proformas.slice(start, end);
  }

  viewDetails(id: number): void {
    this.proformaService.getById(id).subscribe({
      next: (data) => {
        this.selectedProforma = { ...data };
        this.isEditing = false;
      },
      error: (err) => console.error('Failed to fetch invoice', err),
    });
  }

  enableEdit(): void {
    this.isEditing = true;
  }

  saveChanges(): void {
    if (!this.selectedProforma) return;
    this.proformaService.update(this.selectedProforma).subscribe({
      next: (updated) => {
        alert('Proforma updated successfully!');
        this.selectedProforma = updated;
        this.isEditing = false;
        this.getAllProformas();
        this.selectedProforma = null;
      },
      error: (err) => console.error('Update failed', err),
    });
  }

  cancelEdit(): void {
    if (this.selectedProforma?.id) {
      this.viewDetails(this.selectedProforma.id);
    }
  }
  closeDetails() {
    this.selectedProforma = null;
  }
}
